import React from "react";

import PaymentStatusCellContent from "../components/PaymentStatusCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function paymentStatus({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.PaymentStatus,
		(item) => <PaymentStatusCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default paymentStatus;
